window.theme = window.theme || {};

Handlebars.registerHelper('ifEquals', function(arg1, arg2) {
  return (arg1 == arg2) ? (this) : !(this);
});
Handlebars.registerHelper('ifLess', function(arg1, arg2) {
  return (arg1 < arg2) ? (this) : !(this);
});

let formattedCurrency = $('#shop_currency_val').data('currency');
if(formattedCurrency){
  formattedCurrency = formattedCurrency.replaceAll("/", '');
}
theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').text();

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  var shop_currency = $('#shop_currency_val').text();
  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options){

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ''));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
    });
  };

  itemAddedCallback = function (product) {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart){
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  addPreorderProperty = function(cart){
    //SAMPLE ITEM { '42694468534430' : "February 01, 2024" }
    const preorderItems = [
      {'41722373505182': "January 01, 2024"},
      {'41722374553758': "January 01, 2024"},
      {'41665659764894': "December 16, 2023"},
      {'41665659240606': "December 16, 2023"},
      {'41722373210270':  "January 10, 2024"},
      {'41722374258846':  "January 10, 2024"},
      {'41508601200798':  "December 25, 2023"},
      {'41508601168030':  "December 25, 2023"},
      {'41508601102494':  "December 25, 2023"},
      {'41508601069726':  "December 25, 2023"},
      {'41508601036958':  "January 02, 2024"},
      {'41508600971422':  "December 25, 2023"},
      {'41508600709278': "December 25, 2023" },
      {'41508600742046': "December 25, 2023"},
      {'41508600807582': "December 25, 2023"},
      {'41508600840350': "December 25, 2023"},
      {'41508600873118': "December 25, 2023"},
      {'41508600905886': "December 25, 2023"},
      {'41905931780254': "January 02, 2024"},
      {'41905910710430': "January 02, 2024"},
      {'41905910743198': "January 02, 2024"},
      {'41905931845790': "January 02, 2024"},
      {'41905910972574': "January 02, 2024"},
      {'41905911005342': "January 02, 2024"},
      {'41905931911326': "January 02, 2024"},
      {'41905911234718': "January 02, 2024"},
      {'41905911267486': "January 02, 2024"},
      {'41905911431326': "January 02, 2024"},
      {'41905931976862': "January 02, 2024"},
      {'41905911496862': "January 02, 2024"},
      {'41905911529630': "January 02, 2024"},
      {'41905911693470': "January 02, 2024"},
      {'41905932042398': "January 02, 2024"},
      {'41905911759006': "January 02, 2024"},
      {'41905911791774': "January 02, 2024"},
      {'41905911955614': "January 02, 2024"},
      {'41905932107934': "January 02, 2024"},
      {'41905912021150': "January 02, 2024"},
      {'41905912053918': "January 02, 2024"},
      {'41901920911518': "January 07, 2024"},
      {'41901921042590': "January 07, 2024"},
      {'41508600774814': "January 02, 2024"},
      {'41901920714910': "January 02, 2024"},
      {'41901920452766': "January 02, 2024"},
      {'41901920583838': "January 02, 2024"},
      {'41901921173662': "December 30, 2023"},
      {'41901920387230': "December 30, 2023"},
      {'41901920419998': "December 30, 2023"},
      {'41901920485534': "December 30, 2023"},
      {'41901920518302': "December 30, 2023"},
      {'41901920551070': "December 30, 2023"},
      {'41901920616606': "December 30, 2023"},
      {'41901920649374': "December 30, 2023"},
      {'41901920747678': "December 30, 2023"},
      {'41901921304734': "December 30, 2023"},
      {'41901921370270': "December 30, 2023"},
      {'41901921534110': "December 30, 2023"},
      {'41901921566878': "December 30, 2023"}
      
    ]
    if(preorderItems.length > 0){
       cart.items.map((item) => {
          const preorderItem = preorderItems.find((preorderItem) => item.variant_id == Object.keys(preorderItem)[0])
          if(preorderItem){
            if('_rack_builder' in item.properties && !('Ship Date' in item.properties)){
              item.properties['Ship Date'] = preorderItem[item.variant_id]
              let updateLine = {
                id: item.key,
                properties: {
                  'Ship Date': preorderItem[item.variant_id]
                }
              }
              $.ajax({
                url: "/cart/change.js",
                type: "POST",
                data: JSON.stringify(updateLine), 
                contentType: "application/json",
                dataType: 'json'
                });
            }
          }
           
        })
    }
  }

  let allCartComponents = [];
  buildCart = function(cart){
    $cartContainer.empty();
    if (cart.item_count == 0) {
      $cartContainer.append('<div class="empty_cart"><h3 class="empty_cart_slide_cls"> Your cart is currently empty.</h3><div class="cart-container"><div class="view-cart"><a href="/collections/equipment" class="signpost-button bordered_button">Shop now</a></div></div></div>');
      $('.discount-step').hide();
      cartCallback(cart);
      return;
    }else{
      $('.discount-step').show();
      //$('.shipping-method').show();
    }
    var items = [], item = {}, data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    
    //addPreorderProperty(cart);
    $.each(cart.items, function(index, cartItem){
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var itemProperties = {};
      var skipBundleItem = false;
      var itemPrice = cartItem.original_price;
      var itemLinePrice = cartItem.original_line_price;
      let bundleID = null;
      if (cartItem.properties !== null) {
        var bundlePropertyCount = Object.keys(cartItem.properties).filter(p => p.includes("pc_pricing")).length;
        if ('_customizer_id' in cartItem.properties){
          bundleID = cartItem.properties['_customizer_id']
        }
        if(bundlePropertyCount > 1) {
          var parentRef = cartItem.properties._pc_pricing_ref;
          var bundledVariants = cart.items.filter(item => {
            if(item.properties === null) return false;
            var hasParentRef = Object.keys(item.properties).includes("_pc_pricing_ref");
            var isCurrent = item.id === cartItem.id;
            if(!hasParentRef || isCurrent) {
              return false;
            }
            return parentRef === item.properties._pc_pricing_ref ? true : false;
          });

          for(var variant of bundledVariants) {
            itemPrice += variant.price;
            itemLinePrice += variant.line_price;
          }

        } else if (bundlePropertyCount === 1) {
          skipBundleItem = true;
        }

        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) !== '_' && value) {
              itemProperties[key] = value;
          }
        });
        
      }
      if ("wholesale" in $cartContainer[0].dataset) {
          itemPrice = itemPrice * .9;
      }
      if(Object.keys(itemProperties).find((item) => item === "Storage Discount")){
         itemPrice = itemPrice * .9;
      }

      let cartAttributes;
      if (Array.isArray(cartItem?.properties?.fields)) {
        cartAttributes = cartItem.properties.fields.filter(item => !item.key.startsWith('_'));
      }

      const itemProps = cartItem.properties?._bundleJSON?.replace(/=>/g, ':');
      let itemArray = itemProps != undefined ? JSON.parse(itemProps) : [];
      let apiData = itemArray.filter((item => item.includes('{'))).map(item => JSON.parse(item));
      apiData = apiData
        .filter((component) => component.properties._bundleId == cartItem.key.split(':')[0])
        .map(obj => {
          obj.properties = obj.properties || {};
          obj.properties._bundleData = {
            id: obj.id,
            quantity: obj.quantity,
            properties: {
              _bundleId: obj.properties._bundleId,
              _parentSKU: obj.properties._parentSKU,
              _priceCorrection: obj.properties._priceCorrection,
              _originalQuant: obj.properties._originalQuant
            }
          };
        return obj;
      });

      const existingKeys = new Set(
        allCartComponents.map(component => `${component.id}:${component.properties._bundleId}`)
      );
      const filteredApiData = apiData.filter(component => {
        const key = `${component.id}:${component.properties._bundleId}`;
        return !existingKeys.has(key); 
      });
      allCartComponents = allCartComponents.concat(filteredApiData);

      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: itemProperties.fields,
        cartProperties: cartAttributes != null ? cartAttributes : null,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        allowEdit: cartItem?.properties?._componentQuant ? false : true,
        itemQty: cartItem.properties._componentQuant > 1 ? cartItem.properties._componentQuant : cartItem.quantity,
        price: Shopify.formatMoney(itemLinePrice, formattedCurrency),
        lineprice: Shopify.formatMoney(itemLinePrice, formattedCurrency),
        discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), formattedCurrency) ,
        discounts: cartItem.discounts,
        discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
        vendor: cartItem.vendor,
        sku: cartItem.sku,
        apiData: apiData,
        REP_product: cartItem.properties
      };
      
      if(bundleID){
        item['bundleID'] = bundleID
      }
      
      if(!skipBundleItem) {
        items.push(item);
      }
    });

    /*--------LPU--Properties base--------*/
    
    var non_rep_sum = 0;
    let cartDiscount = 0;
    $.each(cart.items, function(index, cartItem){
      var isrepproduct = cartItem.properties._non_REP_product;
      var ispreorderpro = cartItem.properties.item;
      var product_is_rep_count = '';
      var cartItempricenw = Shopify.formatMoney(cartItem.price, formattedCurrency);
      if(isrepproduct == "Yes" || ispreorderpro == "Pre-ordered items"){
        var cartItemprice = cartItem.quantity * cartItem.price;
        non_rep_sum += cartItemprice;
      }
      if(Object.keys(cartItem.properties).find((item) => item === "Storage Discount")){
         cartDiscount += (cartItem.original_line_price * .1);
      }
    });

    var reward_counter = cart.original_total_price - non_rep_sum;
    reward_counter = Shopify.formatMoney(reward_counter, formattedCurrency);
    reward_counter = reward_counter.replace("$", "").replace(',', '');
    reward_counter = Math.floor(reward_counter);
    var count_discount_TTP = reward_counter;
    var loccal_pick_up_discount = 0;
    if(count_discount_TTP >= 0 && count_discount_TTP <= 2500){
      loccal_pick_up_discount =  ((10 * count_discount_TTP) / 100).toFixed(2);
    } else if(count_discount_TTP >= 2501 && count_discount_TTP <= 7500 ){
      loccal_pick_up_discount =  ((12.5 * count_discount_TTP) / 100).toFixed(2);
    } else{
      loccal_pick_up_discount =  ((15 * count_discount_TTP) / 100).toFixed(2);
    }
    $('.no_reward_grid .dicount_10cent').text("$"+ loccal_pick_up_discount + " off");
    
    // var reward_per_doll = $('.rewards_skip_sku').attr("data-number");
    // var final_reward = reward_counter * reward_per_doll;
    // $('.reward_custom_count .reward_custom_point .loyality_point').text(final_reward);
    // if (final_reward <= 0) {
    //   $('.reward_custom_count').hide();
    // } else{
    //   $('.reward_custom_count').show();
    // }

  //PROGRESS BAR 
  let $progressBar = $('[data-progress-bar]').first();
  if($progressBar){
    const $maxTier = $progressBar.attr('data-progress-bar');
    const $bar = $progressBar.find('[data-bar]');
    const currentProgress = Math.floor(((cart.total_price / 100) / $maxTier) * 100);
    $($bar).css('width', currentProgress + '%');
  }

  /*--------Reward New----------*/
  var get_sku_from_CMS = $('.rewards_skip_sku').html();
  var get_sku_from_CMS_array = get_sku_from_CMS.split(",");
  var non_rep_sum_Rewards = 0;
  $.each(cart.items, function(index, cartItem){
    var sku_of_item = cartItem.sku;
    var isinclude = get_sku_from_CMS_array.includes(sku_of_item);
    var  cartItempricenw = Shopify.formatMoney(cartItem.price, formattedCurrency);
    if(isinclude == true){
      var cartItemprice = cartItem.quantity * cartItem.price;
      non_rep_sum_Rewards += cartItemprice;
    }
    
});
var reward_counter_Rewards = cart.original_total_price - non_rep_sum_Rewards;
    reward_counter_Rewards = Shopify.formatMoney(reward_counter_Rewards, formattedCurrency);
    reward_counter_Rewards = reward_counter_Rewards.replace("$", "").replace(',', '');
    reward_counter_Rewards = Math.floor(reward_counter_Rewards);

    var reward_per_doll_Rewards = $('.rewards_skip_sku').attr("data-number");
    var final_reward_Rewards = reward_counter_Rewards * reward_per_doll_Rewards;
    
    if (final_reward_Rewards <= 0) {
      $('.reward_custom_count').hide();
    } else{
      $('.reward_custom_count').show();
    }
    let total = cart.original_total_price
    if ("wholesale" in $cartContainer[0].dataset) {
          total = total * .9;
      }
    total = total - cartDiscount
    if (window.location.href.indexOf("ca.") > -1) {
	  var cart___tottal = "CAD " + Shopify.formatMoney(total, formattedCurrency);
      let cadPoints = ((cart.original_total_price - non_rep_sum_Rewards)/100)*1.1;
      let convertedUSDDollar = Math.ceil(cadPoints/Shopify.currency.rate)
      final_reward_Rewards = convertedUSDDollar * reward_per_doll_Rewards;
      final_reward_Rewards = Math.floor(final_reward_Rewards);
    }
    else{
      var cart___tottal = Shopify.formatMoney(total, formattedCurrency);
    }
     $('.reward_custom_count .reward_custom_point .loyality_point').text(final_reward_Rewards);
    
    data = {
      items: items,
      note: cart.note,
      totalPrice: cart___tottal,
      totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
    };

    $cartContainer.append(template(data));
    cartCallback(cart);
  };

  cartCallback = function(cart){
    $body.trigger('ajaxCart.afterCartLoad', cart);
    wc_theme_source.lib.on_cart_update(cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    
    $('.discount-wrap li').each(function(){
      $('.elg_for_free').hide();
      var qty = $(this).attr('data-qty');
      if(cart.item_count == 1){
        $('.discount-wrap li').removeClass('active');
        $('.discount-wrap li[data-qty=1]').addClass('active');
        var offer = $('.discount-wrap li[data-qty=2]').data('offer');
        $('.offer-txt .offeraway').text(offer);
        $('.discount-wrap li[data-qty=1]').addClass('active');
      }else if(cart.item_count == 2){
        $('.discount-wrap li').removeClass('active');
        var offer = $('.discount-wrap li[data-qty=3]').data('offer');
        $('.offer-txt .offeraway').text(offer);
        $('.discount-wrap li[data-qty=1] , .discount-wrap li[data-qty=2]').addClass('active');
      }else if(cart.item_count == 3){
        $('.discount-wrap li').removeClass('active');
        var offer = $('.discount-wrap li[data-qty=4]').data('offer');
        $('.offer-txt .offeraway').text(offer);
        $('.discount-wrap li[data-qty=1] , .discount-wrap li[data-qty=2] , .discount-wrap li[data-qty=3]').addClass('active');
      }else if(cart.item_count == 4){
        $('.discount-wrap li').removeClass('active');
        var offer = $('.discount-wrap li[data-qty=5]').data('offer');
        $('.offer-txt .offeraway').text(offer);
        $('.discount-wrap li[data-qty=1] , .discount-wrap li[data-qty=2] , .discount-wrap li[data-qty=3] , .discount-wrap li[data-qty=4]').addClass('active');
      }else if(cart.item_count >= 5){
        $('.discount-wrap li').removeClass('active');
        $('.offer-txt.not_eligible_offer, .not_elgib').css('display','none');
        $('.offer-txt.eligible_offer, .elg_for_free').css('display','block');
        $('.discount-wrap li[data-qty=1] , .discount-wrap li[data-qty=2] , .discount-wrap li[data-qty=3] , .discount-wrap li[data-qty=4] , .discount-wrap li[data-qty=5]').addClass('active');
      }else{
        $('.offer-txt.not_eligible_offer, .not_elgib').css('display','block');
        $('.offer-txt.eligible_offer, .elg_for_free').css('display','none');
        $('.elg_for_free').show();
        $('.discount-wrap li').removeClass('active');
      }
    });
    
    var $FreeShippingCal = $('[data-banner-free-shipping-cal]');
    var FreeShippingAmout = parseInt($('[data-banner-free-shipping-cal]').attr('data-cart-threshold-price'));
    var subtotal = cart.total_price;
    if(subtotal < FreeShippingAmout){
      var remain_total = (FreeShippingAmout - subtotal);
      var remain_total_amount = Shopify.formatMoney(remain_total, formattedCurrency);
      var freeShippingMsg = $('[data-banner-free-shipping-cal]').attr('data-free-shipping-message');
      var replaceAmount = "{'{'amount'}'}'";
      replaceAmount = replaceAmount.split("'").join("");
      if(freeShippingMsg != '' || freeShippingMsg != null || freeShippingMsg != undefined){
        var freeShippingMsg = freeShippingMsg.replace(replaceAmount, remain_total_amount);
        $('.elg_for_free').hide();
      }
      $($FreeShippingCal).html(freeShippingMsg);
      $('.elg_for_free').hide();
    }else {
      $($FreeShippingCal).html($('[data-banner-free-shipping-cal]').attr('data-congo-message'));
      $('.elg_for_free').show();
      $('.not_elgib').hide();
    }
    var barCount = Number((cart.total_price * 100/FreeShippingAmout))
    if(barCount < 100){
      $('.shipping-bar span').css('width',barCount+'%');
    } else{
      $('.shipping-bar span').css('width','100%');
    }
  };

  

  adjustCart = function(){
    $body.on('click', '.ajaxcart__qty-adjust', function(event) {
      if (isUpdating) {
        return;
      }

      var $el = $(this), componentParent = $el.data('id').split(':')[0] ,line = $el.data('line'), line_id = $el.data('id'), $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'), qty = parseInt($qtySelector.val());
      var qty = validateQty(qty);
      var $min_cart_qty = false, $min_cart_value = 0;
      $.getJSON('/cart.js', function($th_cart_json){
        if($th_cart_json.item_count > 0){
          $.each($th_cart_json.items, function(cart_index, cart_value){
            if(cart_value.key == line_id){
              if(cart_value.properties != null){
                $.each(cart_value.properties, function(pro_index, pro_value){
                  if(pro_index == '_min_qty_limit'){
                    $min_cart_qty = true;
                    $min_cart_value = parseInt(pro_value);
                  }
                });
              }
            }
            if(cart_index === ($th_cart_json.items.length -1)){
              if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
              } else {
                qty -= 1;
                if($min_cart_qty){
                  if (qty <= $min_cart_value) qty = $min_cart_value;
                } else{
                  if (qty <= 0) qty = 0;
                }
              }
        
              if(line){
                updateQuantity(line, qty, componentParent);
              } else{
                $qtySelector.val(qty);
              }
        
              if(event.target.closest(".n_row").querySelector(".product_variant").childElementCount > 3){
                window.location = "/cart";
              }
            }
          });
        }
      });
    });
    
    $body.on('change', '.ajaxcart__qty-select', function() {
      if (isUpdating) {
        return;
      }
      var $option = $(this).find('option:selected').val();
      var $el = $(this),
          line = $el.data('line'),
          line_id = $el.data('id'),
          qty = parseInt($el.find('option:selected').val());

      var qty = validateQty(qty);
      var $min_cart_qty = false, $min_cart_value = 0;
      $.getJSON('/cart.js', function($th_cart_json){
        if($th_cart_json.item_count > 0){
          $.each($th_cart_json.items, function(cart_index, cart_value){
            if(cart_value.key == line_id){
              if(cart_value.properties != null){
                $.each(cart_value.properties, function(pro_index, pro_value){
                  if(pro_index == '_min_qty_limit'){
                    $min_cart_qty = true;
                    $min_cart_value = parseInt(pro_value);
                  }
                });
              }
            }
            if(cart_index === ($th_cart_json.items.length -1)){
              if($min_cart_qty){
                if (qty <= $min_cart_value) qty = $min_cart_value;
              }
              if(line || qty){
                updateQuantity(line, qty);
              }
            }
          });
        }
      });
    });
    let bundleID = null
    function removePreorderBundle(cart){
      let items = {};
      cart.items.map((item) => { 
        if ('_customizer_id' in item.properties && item.properties['_customizer_id'] == bundleID ){
          items[item.key] = 0;
        }
      })
      wc_theme_source.lib.cart_remove_items({updates: items}, adjustCartCallback);
    }
    $body.on('click', '.cart_remove_item', function(){
      var line = $(this).attr('data-line');
      if ($(this).attr("data-bundle-id")) {
        bundleID = $(this).attr("data-bundle-id");
         wc_theme_source.lib.get_cart(removePreorderBundle);
      }else{
        bundleID = null;
        wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
      }
    });
    $body.on('click', '.cart_clear', function(){
      wc_theme_source.lib.cart_clear_all()
      setTimeout(function() {
        location.reload();
      })

    });
    
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          line_id = $el.data('id'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);
      var $min_cart_qty = false, $min_cart_value = 0;
      $.getJSON('/cart.js', function($th_cart_json){
        if($th_cart_json.item_count > 0){
          $.each($th_cart_json.items, function(cart_index, cart_value){
            if(cart_value.key == line_id){
              if(cart_value.properties != null){
                $.each(cart_value.properties, function(pro_index, pro_value){
                  if(pro_index == '_min_qty_limit'){
                    $min_cart_qty = true;
                    $min_cart_value = parseInt(pro_value);
                  }
                });
              }
            }
            if(cart_index === ($th_cart_json.items.length -1)){
              if($min_cart_qty){
                if (qty <= $min_cart_value) qty = $min_cart_value;
              }
              if(line){
                updateQuantity(line, qty);
              }
            }
          });
        }
      });
    });
    
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });
    
    function updateQuantity(line, qty, parent) {
      // Add activity classes when changing cart quantities
      var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass('is-loading');
      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      const neededComponents = allCartComponents.filter((component) => component.properties?._bundleId == parent)
      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback, neededComponents);
      }, 250);
    }
    
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      wc_theme_source.lib.get_cart(buildCart);
      isUpdating = false;
    }, 150)
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };
    
  return module;

}(ajaxCart || {}, jQuery));